<template>
  <page-layout
    :header="isMobile"
    :loaded="currentUserLoaded"
    title="Recruiting Dashboard"
  >
    <div class="content-main">
      <div class="content-main__centered">
        <h4 class="appMain--text mb-2">Hello {{ userName }}!</h4>
        <p class="mb-6">
          Track your recruiting activity and stay on top of your outreach goals.
        </p>

        <div>
          <div class="d-flex justify-space-between align-center mb-4">
            <h5 class="text-h6 mb-0">Office Overview</h5>
            <v-chip
              v-if="!loading && activityDateRange"
              small
              outlined
              color="primary"
            >
              {{ activityDateRange }}
            </v-chip>
          </div>

          <v-row v-if="loading">
            <v-col v-for="n in 5" :key="n" class="pa-1">
              <v-skeleton-loader
                class="metric-card-placeholder"
                type="card"
                :height="isMobile ? 146 : 192"
              />
            </v-col>
          </v-row>

          <v-row v-else>
            <v-col
              v-for="stat in statCards"
              :key="stat.key"
              class="d-flex pa-1"
            >
              <v-card
                outlined
                hover
                class="metric-card transition-swing d-flex flex-column"
              >
                <v-card-text class="text-center pa-4 pa-sm-6">
                  <v-avatar
                    :size="isMobile ? 44 : 56"
                    :color="stat.color + ' lighten-5'"
                    class="mb-3"
                  >
                    <v-icon color="primary" :size="isMobile ? 22 : 28">
                      {{ stat.icon }}
                    </v-icon>
                  </v-avatar>
                  <div class="text-h4 font-weight-bold mb-1 appMain--text">
                    {{ getStatForKey(stat.key) }}
                  </div>
                  <div class="text--secondary font-weight-medium text-body-2">
                    {{ stat.label }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </page-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'RecruitingHome',
  data() {
    return {
      loading: true,
      stats: {
        min_activity_date: null,
        max_activity_date: null,
        contacts_created: 0,
        contacts_reached: 0,
        received_call: 0,
        received_sms: 0,
        interview_scheduled: 0,
      },
      statCards: [
        {
          icon: 'mdi-account-plus',
          label: 'Contacts Added',
          key: 'contacts_created',
        },
        {
          icon: 'mdi-phone',
          label: 'Called',
          key: 'received_call',
        },
        {
          icon: 'mdi-message-text',
          label: 'Texted',
          key: 'received_sms',
        },
        {
          icon: 'mdi-account-multiple',
          label: 'Reached',
          key: 'contacts_reached',
        },
        {
          icon: 'mdi-calendar-check',
          label: 'Interview Scheduled',
          key: 'interview_scheduled',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('users', ['currentUser', 'currentUserLoaded']),

    userName() {
      return this.currentUser?.first_name || '';
    },

    activityDateRange() {
      return 'Last 7 days';
    },
  },
  methods: {
    ...mapActions('vector', ['loadRecruitingActivityReport']),
    getStatForKey(key) {
      if (!key || !this.stats) return 0;
      return this.stats[key] || 0;
    },

    async fetchRecruitingActivityReport() {
      this.loading = true;
      try {
        const res = await this.loadRecruitingActivityReport();
        const stats = Array.isArray(res.data) ? res.data[0] : {};
        for (const statKey in this.stats) {
          this.stats[statKey] = stats[statKey] || 0;
        }
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchRecruitingActivityReport();
  },
};
</script>

<style lang="less">
.metric-card {
  border-radius: 8px;
  width: 100%;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  }
}

.metric-card,
.metric-card-placeholder {
  @media only screen and (max-width: 680px) {
    min-width: 130px !important;
  }
}
</style>
